import React from 'react';
import Header from '../components/layout/Header';
import Forum from '../components/sections/Forum';
import Footer from '../components/layout/Footer';

const ForumPage = () => {
  return (
    <>
      <Header />
      <Forum />
      <Footer />
    </>
  );
};

export default ForumPage;
